const defaultState = {
  steinway: {
    text: 'Steinway D-274',
    extension: 'mp3',
    size: '36.3 MB',
    sounds: new Map()
  },
  yamaha: {
    text: 'Yamaha C5',
    extension: 'wav',
    size: '75.0 MB',
    sounds: new Map()
  }
};

const state = Object.assign({}, defaultState);

const mutations = {
  RESET_SOUND_DATA(state) {
    for (const soundId in state) {
      state[soundId].sounds.clear();
    }
  },
  SET_SOUND_DATA(state, data) {
    state[data.soundId].sounds.set(data.noteId, data.origSound);
  }
};

const actions = {
  resetSoundData: ({ commit }) => {
    commit('RESET_SOUND_DATA');
  },
  setSoundData: ({ commit }, { soundId, noteId, origSound }) => {
    commit('SET_SOUND_DATA', { soundId, noteId, origSound });
  }
};

export default {
  state,
  mutations,
  actions
};
